module.exports = __webpack_public_path__ + "static/media/29FUNOV2.5978bf5e.jpg";